export default "__VITE_ASSET__CtzSxDRl__"